import React from 'react';
import { useTranslation } from 'react-i18next';
import StackedPercentageAreaChart from '../../charts/StackedPercentageAreaChart';
import { useMemo } from 'react';
import BlockChart from '../../BlockChart';
import { useGetAppSdkVersionPerDayQuery } from '../../../api/appApiSlice';
import versionCompare from '../../../services/versionCompare';
import { dataToStackChartData } from '../../../services/data/charts/dataToStackChartData';

const SdkVersionEvolution = ({appId, filter}) => {
  const { t } = useTranslation();
  const { data = [], isSuccess, isLoading, refetch } = useGetAppSdkVersionPerDayQuery({appId, filter})
  const formattedData = useMemo(() => dataToStackChartData("sdk_version")(data)).sort((a,b) => versionCompare(b.name,a.name) )
  const loaderProps={isSuccess, isLoading, retry: refetch}

  return (
    <BlockChart title={t('version.device_per_sdk_version_evolution')} {...loaderProps}>
      <StackedPercentageAreaChart data={formattedData} legendOptions={{show: false}}/>
    </BlockChart>
  )
}

export default SdkVersionEvolution
